import { render } from "./PlanandCases.vue?vue&type=template&id=6b8b8b5d&scoped=true"
import script from "./PlanandCases.vue?vue&type=script&lang=js"
export * from "./PlanandCases.vue?vue&type=script&lang=js"

import "./PlanandCases.vue?vue&type=style&index=0&id=6b8b8b5d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b8b8b5d"]])

export default __exports__